// extracted by mini-css-extract-plugin
module.exports = {"maxWidthSmallScreenDesktop":"960px","imageWithTextProductDetailsSection":"stackedImageWithTextProductDetailsSection_imageWithTextProductDetailsSection__rCJN7"};